'use client';

// Third Party
import * as React from 'react';
import Image from 'next/image';

// Utils
import { getListPagePartners } from '@utils/partners';

// UI
import { Typography } from '@components/typography';

const pmsIntegrations = getListPagePartners();

export const PartnerSection: React.FC = () => {
  // Duplicate the array for seamless looping
  const logos = [...pmsIntegrations, ...pmsIntegrations];

  return (
    <div className="place-items-center text-primary-main pt-6">
      <Typography
        component="p"
        variant="body1"
        className="text-lg text-center uppercase font-semibold"
      >
        Savvy is connected with the following property management systems
      </Typography>

      {/* Full-bleed yellow background for the carousel */}
      <div className="relative -mx-8 xl:rounded-t-2xl sm:max-w-7xl bg-secondary-main py-2 mt-6">
        <div className="w-full sm:max-w-7xl overflow-hidden">
          <div
            className="flex items-center gap-12 animate-partner-marquee overflow-hidden"
            style={{
              width: `${logos.length * 12}rem`,
            }}
          >
            {logos.map((pmsIntegration, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center min-w-[8rem]"
              >
                <Image
                  src={pmsIntegration.logoSvg}
                  alt={pmsIntegration.title}
                  className="w-full h-16 object-contain mb-2"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
